import {combineReducers, createStore,applyMiddleware} from "redux";
import thunk from "redux-thunk";
import authorizationReducer from "../reducer/authorization";

let reducer = combineReducers({
    authorization:authorizationReducer
});
const store = createStore(reducer);
export default store;